export const CUSTOM_CONTENT_AUDIENCE_TYPES = {
  PUBLIC: 'public',
  CUSTOM: 'custom',
}

export const CUSTOM_CONTENT_FIELDS = {
  AUDIENCE_TYPE: 'audience_type',
  BUSINESS_ACCOUNT_IDS: 'business_account_ids',
}

export const CUSTOM_CONTENT_ACCOUNT_PAGE_SIZE = '25'

export const CUSTOM_CONTENT_STRINGS = {
  toggleLabel: 'Is Custom Content',
  enterpriseAccountsLabel: 'Enterprise Accounts',
  enterpriseAccountsPlaceholder: 'Search enterprise accounts',
  enterpriseAccountsNoOptionsEnabled: 'type to search enterprise accounts',
  enterpriseAccountsNoMatches:
    'No accounts found. Try a different search term.',
  enterpriseAccountsNoOptionsDisabled:
    'Enable Is Custom Content to search enterprise accounts',
  courseFilterContentTypeLabel: 'Content Type',
  courseFilterContentTypePlaceholder: 'Select content type',
  courseFilterContentTypeAllLabel: 'All',
  courseFilterContentTypePublicLabel: 'Public',
  courseFilterContentTypeCustomLabel: 'Custom',
  publicToCustomTooltip:
    'This action cannot be performed. Once content is set to public, it cannot be converted to custom.',
  publicStateHelperText:
    'Once content is set to public,\nit cannot be converted to custom.',
  convertToPublicTitle: 'Convert content to Public?',
  convertToPublicBody:
    'Converting this content to Public will make it accessible to all eligible users, including B2C users and all enterprise accounts. This action cannot be automatically reversed.\nYou must save the content to apply changes.',
  convertToPublicAcceptText: 'Confirm',
  convertToPublicCancelText: 'Cancel',
  removeAccountsTitle: 'Remove enterprise accounts?',
  removeAccountsBody:
    'Removing enterprise account access cannot be automatically reversed. Do you want to continue?',
  removeAccountsAcceptText: 'Remove',
  removeAccountsCancelText: 'Cancel',
  createMissingAccountsError:
    'Enterprise Accounts is required when creating custom content.',
  enterpriseAccountsLoadError:
    'Enterprise Accounts could not be loaded. Please try again.',
}

export const COURSE_SAVE_FLOW_ERROR_CODES = {
  COURSE_SAVE_FAILED: 'COURSE_SAVE_FAILED',
  ACCESS_TYPE_UPDATE_FAILED: 'ACCESS_TYPE_UPDATE_FAILED',
  ASSIGN_FAILED: 'ASSIGN_FAILED',
  UNASSIGN_FAILED: 'UNASSIGN_FAILED',
  PUBLIC_TO_CUSTOM_NOT_ALLOWED: 'PUBLIC_TO_CUSTOM_NOT_ALLOWED',
  CUSTOM_CREATE_MISSING_ACCOUNTS: 'CUSTOM_CREATE_MISSING_ACCOUNTS',
}

export const COURSE_SAVE_FLOW_ERROR_NOTIFICATIONS = {
  [COURSE_SAVE_FLOW_ERROR_CODES.COURSE_SAVE_FAILED]:
    'Course could not be saved. Please try again.',
  [COURSE_SAVE_FLOW_ERROR_CODES.ACCESS_TYPE_UPDATE_FAILED]:
    'Course was saved, but updating access type failed.',
  [COURSE_SAVE_FLOW_ERROR_CODES.ASSIGN_FAILED]:
    'Course was saved, but assigning enterprise accounts failed.',
  [COURSE_SAVE_FLOW_ERROR_CODES.UNASSIGN_FAILED]:
    'Course was saved, but removing enterprise accounts failed.',
}
